import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { erpApi, formatApiErrorDetail } from "@/lib/erpApi";

const ACTION_LABELS = {
  login: { label: "Autentificare", color: "bg-blue-100 text-blue-700" },
  create: { label: "Creare", color: "bg-emerald-100 text-emerald-700" },
  update: { label: "Actualizare", color: "bg-amber-100 text-amber-700" },
  delete: { label: "Ștergere", color: "bg-red-100 text-red-700" },
  reset_password: { label: "Resetare parolă", color: "bg-purple-100 text-purple-700" },
  change_password: { label: "Schimbare parolă proprie", color: "bg-indigo-100 text-indigo-700" },
};

const ENTITY_LABELS = {
  employee: "Angajat",
  role: "Rol",
  auth: "Autentificare",
};

export default function TrasabilitateTab() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    erpApi
      .get("/audit")
      .then((r) => setLogs(r.data))
      .catch((err) => toast.error(formatApiErrorDetail(err?.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  const fmt = (iso) => {
    try {
      return new Date(iso).toLocaleString("ro-RO");
    } catch {
      return iso;
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center py-20 text-slate-400">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );

  return (
    <div className="space-y-4" data-testid="erp-trasabilitate-panel">
      <p className="text-sm text-slate-500">{logs.length} înregistrări (ultimele 500)</p>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Data</TableHead>
              <TableHead>Utilizator</TableHead>
              <TableHead>Acțiune</TableHead>
              <TableHead>Entitate</TableHead>
              <TableHead>Detalii</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l) => {
              const a = ACTION_LABELS[l.action] || { label: l.action, color: "bg-slate-100 text-slate-700" };
              return (
                <TableRow key={l.id} data-testid={`erp-audit-row-${l.id}`}>
                  <TableCell className="text-slate-500 whitespace-nowrap text-xs">{fmt(l.ts)}</TableCell>
                  <TableCell className="text-slate-600 text-sm">{l.actor_email}</TableCell>
                  <TableCell>
                    <Badge className={`${a.color} border-0 font-medium`}>{a.label}</Badge>
                  </TableCell>
                  <TableCell className="text-slate-600 text-sm">{ENTITY_LABELS[l.entity] || l.entity}</TableCell>
                  <TableCell className="text-slate-500 text-sm">{l.details}</TableCell>
                </TableRow>
              );
            })}
            {logs.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-10 text-slate-400">
                  Nicio înregistrare.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
